import { createSlice } from "@reduxjs/toolkit";
import { transformBrandConfigData } from "../components/Partners/DataIntegrations/helperOfBrandConfig/brandConfigHelpers";

const initialState = {
  selectedBrandName: "",
  selectedIntegrationStatus: [],
  selectedStuckAt: [],
  selectedReason: [],
  selectedAffiliatedSystem: [],
  selectedWebsite: [],
  selectedLastRun: "",
  brandConfigurationReportList: [],
  brandConfigurationPIEChartsData: [],
  brandConfigReportLoader: false,
  isFetchedBrandConfigReport: false,
  page: 0,
  rowsPerPage: 10,
  brandPropertiesData: [],
  brandBackendRequirementsData: [],
};

const brandConfigurationReportSlice = createSlice({
  name: "brandConfigurationReport",
  initialState,
  reducers: {
    setSelectedBrandName: (state, action) => {
      state.selectedBrandName = action.payload;
    },
    setSelectedIntegrationStatus: (state, action) => {
      state.selectedIntegrationStatus = action.payload;
    },
    setSelectedStuckAt: (state, action) => {
      state.selectedStuckAt = action.payload;
    },
    setSelectedReason: (state, action) => {
      state.selectedReason = action.payload;
    },
    setSelectedAffiliatedSystem: (state, action) => {
      state.selectedAffiliatedSystem = action.payload;
    },
    setSelectedWebsite: (state, action) => {
      state.selectedWebsite = action.payload;
    },
    setSelectedLastRun: (state, action) => {
      state.selectedLastRun = action.payload;
    },
    setBrandConfigReportLoader: (state, action) => {
      state.brandConfigReportLoader = action.payload;
    },
    setBrandConfigurationReportList: (state, action) => {
      state.brandConfigurationReportList = transformBrandConfigData(action.payload) as any; // transformBrandConfigData is a helper functionaction.payload;
    },
    setBrandConfigurationPIEChartsData: (state, action) => {
      state.brandConfigurationPIEChartsData = action.payload;
    },
    setIsFetchedBrandConfigReport: (state, action) => {
      state.isFetchedBrandConfigReport = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setBrandPropertiesData: (state, action) => {
      state.brandPropertiesData = action.payload;
    },
    setBrandBackendRequirementsData: (state, action) => {
      state.brandBackendRequirementsData = action.payload;
    },

    resetBrandConfigurationReportState: () => initialState,
  },
});

export const {
  setSelectedBrandName,
  setSelectedIntegrationStatus,
  setSelectedStuckAt,
  setSelectedReason,
  setSelectedAffiliatedSystem,
  setSelectedWebsite,
  setSelectedLastRun,
  setBrandConfigReportLoader,
  setBrandConfigurationReportList,
  setBrandConfigurationPIEChartsData,
  setIsFetchedBrandConfigReport,
  setPage,
  setRowsPerPage,
  setBrandPropertiesData,
  setBrandBackendRequirementsData,
  resetBrandConfigurationReportState,
} = brandConfigurationReportSlice.actions;
export default brandConfigurationReportSlice.reducer;
